The ISO 3166-1 alpha-2 country code.

For example, "AU" for Australia or "NZ" for New Zealand.
This field has a maximum length of 2 characters.
